import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
import "./plugins/bootstrap-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import numeral from "numeral";
import { firestorePlugin } from "vuefire";
import * as VueGoogleMaps from "vue2-google-maps";
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize
} from "vee-validate";
import en from "vee-validate/dist/locale/en.json";
import * as rules from "vee-validate/dist/rules";
import VueMoment from "vue-moment";
import moment from "moment-timezone";

import BackToTop from "vue-backtotop";

Vue.use(BackToTop);

// Install VeeValidate rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

localize("en", en);

// Install VeeValidate components globally
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCkOkG56cjR2cH4nadQqv5fUHHn8LyATDQ",
    libraries: "places"
  }
});

Vue.use(firestorePlugin);

Vue.filter("formatNumber", function(value) {
  return numeral(value).format("0,0");
});
Vue.use(VueMoment, {
  moment
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
